export const playCopy = {
  play_subnav_title: "Area Bermain",
  play_subnav_config: "Konfig TS",
  play_config_language_blurb: "Bahasa mana yang akan digunakan di editor",
  play_subnav_examples: "Contoh",
  play_subnav_examples_close: "Tutup",
  play_subnav_whatsnew: "Yang Baru",
  play_subnav_settings: "Pengaturan",
  play_settings_tabs_settings: "Tab Sidebar",
  play_downloading_typescript: "Mengunduh TypeScript...", // ketika memuat
  play_downloading_version: "Versi...", // ketika memuat
  play_toolbar_run: "Jalankan",
  play_toolbar_export: "Expor",
  play_toolbar_share: "Bagikan",
  play_sidebar_js: ".JS",
  play_sidebar_dts: ".D.TS",
  play_sidebar_errors: "Galat",
  play_sidebar_errors_no_errors: "Tidak ada galat",
  play_sidebar_logs: "Catatan",
  play_sidebar_logs_no_logs: "Tidak ada catatan",
  play_sidebar_options: "Opsi",
  play_sidebar_options_restart_required: "Dibutuhkan Penyegaran Peramban",
  play_sidebar_options_disable_ata: "Nonaktifkan ATA",
  play_sidebar_options_disable_ata_copy:
    "Nonaktifkan akuisisi dari import dan require otomatis.",
  play_sidebar_options_disable_save: "Nonaktifkan Simpan-saat-Ketik",
  play_sidebar_options_disable_save_copy:
    "Nonaktifkan mengubah URL ketika Anda mengetik.",
  play_sidebar_plugins: "Plugin",
  play_sidebar_featured_plugins: "Plugin Unggulan",
  play_sidebar_plugins_options_external:
    "Plugin Pihak Ketiga <a href='https://www.npmjs.com/search?q=keywords:playground-plugin'>dari npm</a>",
  play_sidebar_plugins_options_external_warning:
    "Peringatan: Kode dari plugin berasal dari pihak ketiga.",
  play_sidebar_plugins_options_modules: "Modul npm kustom",
  play_sidebar_plugins_options_modules_placeholder: "Nama modul dari npm.",
  play_sidebar_plugins_plugin_dev: "Plugin Dev",
  play_sidebar_plugins_plugin_dev_option:
    "Terhubung ke <code>localhost:5000</code>",
  play_sidebar_plugins_plugin_dev_copy:
    "Secara otomatis mencoba menghubungkan ke plugin Area Bermain dalam mode pengembangan. Anda dapat mulai <a href='/dev/playground-plugins/' title='Tautan ke halaman tentang Plugin Area Bermain'>membuat plugin di sini</a>.",
  play_export_report_issue: "Laporkan GitHub isu di TypeScript",
  play_export_copy_md: "Salin sebagai Isu Markdown",
  play_export_copy_link: "Salin sebagai Tautan Markdown",
  play_export_copy_link_preview:
    "Salin sebagai Tautan Markdown dengan Pratinjau",
  play_export_tsast: "Buka di TypeScript Penampil AST",
  play_export_bugworkbench: "Buka di Bug Workbench",
  play_export_sandbox: "Buka di CodeSandbox",
  play_export_stackblitz: "Buka di StackBlitz",
  play_export_clipboard: "URL disalin ke clipboard",
  play_run_js: "Eksekusi JavaScript",
  play_run_ts: "Eksekusi TypeScript yang di-transpile",
  play_run_js_fail: "Eksekusi JavaScript Gagal:",
  play_default_code_sample: `// Selamat datang di Area Bermain TypeScript, ini adalah situs web
// yang memberi Anda kesempatan untuk menulis, berbagi, dan mempelajari TypeScript.

// Anda dapat memikirkannya dengan tiga cara:
//
//  - Tempat untuk mempelajari TypeScript di tempat di mana tidak ada yang bisa rusak
//  - Tempat untuk bereksperimen dengan sintaks TypeScript, dan berbagi URL dengan orang lain
//  - Bak pasir untuk bereksperimen dengan berbagai fitur penyusun TypeScript

const contohVariabel = "Halo Dunia"
console.log(contohVariabel)

// Untuk mempelajari lebih lanjut tentang bahasa tersebut, klik di atas di "Contoh" atau "Yang Baru".
// Mulailah dengan menghapus komentar ini dan dunia adalah area bermain Anda.
  `,

  play_sidebar_js_title: "JavaScript",
  play_sidebar_js_blurb: "Lihat JS yang telah di-transpile",

  play_sidebar_dts_title: "Berkas Definisi",
  play_sidebar_dts_blurb: "Lihat keluaran .d.ts dari kode Anda",

  play_sidebar_err_title: "Galat Penyusun",
  play_sidebar_err_blurb: "Lihat galat penyusun secara penuh",

  play_sidebar_run_title: "Jalankan JavaScript di peramban",
  play_sidebar_run_blurb:
    "Menampilkan keluaran dari menjalankan JavaScript di editor",

  play_sidebar_plugins_title: "Atur Plugin Area Bermain",
  play_sidebar_plugins_blurb:
    "Menangani penambahan/penghapusan ekstensi pihak ketiga ke Area Bermain",

  play_sidebar_ast_title: "[WIP] Penampil AST",
  play_sidebar_ast_blurb: "Periksa TypeScript AST",

  // Notes:
  // Compiler flag information is all from the tsconfig reference info
}
